import React from 'react';
import { Link } from 'react-router-dom';

export const DashboardLink = React.forwardRef((props, ref) => <Link to="/" {...props} ref={ref} />);
export const TestListLink = React.forwardRef((props, ref) => <Link to="/testlist" {...props} ref={ref} />);
export const CreateTestLink = React.forwardRef((props, ref) => <Link to="/createtest" {...props} ref={ref} />);
export const ViewTestLink = React.forwardRef(({ productID, ...props }, ref) => <Link to={`/viewtest/${productID}`} {...props} ref={ref} />);
